import { render, staticRenderFns } from "./TableProjectItem.vue?vue&type=template&id=7c72ed6a&"
import script from "./TableProjectItem.vue?vue&type=script&lang=js&"
export * from "./TableProjectItem.vue?vue&type=script&lang=js&"
import style0 from "./TableProjectItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports